import { render, staticRenderFns } from "./print-shipping-label.vue?vue&type=template&id=6347f137&scoped=true&"
import script from "./print-shipping-label.vue?vue&type=script&lang=ts&"
export * from "./print-shipping-label.vue?vue&type=script&lang=ts&"
import style0 from "./print-shipping-label.vue?vue&type=style&index=0&id=6347f137&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6347f137",
  null
  
)

export default component.exports